function initTabs(container) {
  const root = container || document; // container là section cụ thể

  const buttons = root.querySelectorAll('.collection-tabs-button');
  const tabs = root.querySelectorAll('.collection-tabs-content');

  if (!buttons.length || !tabs.length) return;

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      if(button.classList.contains('active')){
        window.location.href= button.dataset.url
        return;
      }
      // Chỉ xóa active trong root
      buttons.forEach(b => b.classList.remove('active'));
      tabs.forEach(t => t.classList.remove('active'));

      // Thêm active cho button và tab trong root
      button.classList.add('active');
      const activeTab = root.querySelector('.' + button.dataset.tab);
      if (activeTab) activeTab.classList.add('active');
    });
  });
}

// Khi DOM load
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.section-resource-list').forEach(section => initTabs(section));
});

// Khi Shopify section load
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target; // section vừa load
  initTabs(section);
});
